export type ExperienceBundleParams = {
    appId: string;
    appVersion: string;
    locale: string;
    rubric: string;
    tenantScope: string;
};

export type ExperienceManifestResponse = {
    contentVersion: string;
};

export type ExperienceBundleResponse = {
    contentVersion: string;
    translations: Record<string, unknown>;
};

export const flattenTranslations = (
    value: Record<string, unknown>,
    prefix = ''
): Record<string, string> => {
    const result: Record<string, string> = {};

    Object.entries(value ?? {}).forEach(([key, entry]) => {
        const path = prefix ? `${prefix}.${key}` : key;
        if (entry && typeof entry === 'object' && !Array.isArray(entry)) {
            Object.assign(
                result,
                flattenTranslations(entry as Record<string, unknown>, path)
            );
            return;
        }
        if (typeof entry === 'string') {
            result[path] = entry;
        }
    });

    return result;
};
